module.exports = __webpack_public_path__ + "assets/img/icon.0a66be2f.png";